/** unique or primary key constraints on table "board" */
export var Board_Constraint;
(function (Board_Constraint) {
    /** unique or primary key constraint */
    Board_Constraint["BoardsLevelKey"] = "boards_level_key";
    /** unique or primary key constraint */
    Board_Constraint["BoardsPkey"] = "boards_pkey";
})(Board_Constraint || (Board_Constraint = {}));
/** unique or primary key constraints on table "board_exercice_category" */
export var Board_Exercice_Category_Constraint;
(function (Board_Exercice_Category_Constraint) {
    /** unique or primary key constraint */
    Board_Exercice_Category_Constraint["BoardExerciceCategoryPkey"] = "board_exercice_category_pkey";
})(Board_Exercice_Category_Constraint || (Board_Exercice_Category_Constraint = {}));
/** select columns of table "board_exercice_category" */
export var Board_Exercice_Category_Select_Column;
(function (Board_Exercice_Category_Select_Column) {
    /** column name */
    Board_Exercice_Category_Select_Column["BoardId"] = "board_id";
    /** column name */
    Board_Exercice_Category_Select_Column["ExerciceCategoryId"] = "exercice_category_id";
})(Board_Exercice_Category_Select_Column || (Board_Exercice_Category_Select_Column = {}));
/** update columns of table "board_exercice_category" */
export var Board_Exercice_Category_Update_Column;
(function (Board_Exercice_Category_Update_Column) {
    /** column name */
    Board_Exercice_Category_Update_Column["BoardId"] = "board_id";
    /** column name */
    Board_Exercice_Category_Update_Column["ExerciceCategoryId"] = "exercice_category_id";
})(Board_Exercice_Category_Update_Column || (Board_Exercice_Category_Update_Column = {}));
/** unique or primary key constraints on table "board_exercice" */
export var Board_Exercice_Constraint;
(function (Board_Exercice_Constraint) {
    /** unique or primary key constraint */
    Board_Exercice_Constraint["BoardExercicePkey"] = "board_exercice_pkey";
})(Board_Exercice_Constraint || (Board_Exercice_Constraint = {}));
/** select columns of table "board_exercice" */
export var Board_Exercice_Select_Column;
(function (Board_Exercice_Select_Column) {
    /** column name */
    Board_Exercice_Select_Column["BoardId"] = "board_id";
    /** column name */
    Board_Exercice_Select_Column["ExerciceId"] = "exercice_id";
})(Board_Exercice_Select_Column || (Board_Exercice_Select_Column = {}));
/** update columns of table "board_exercice" */
export var Board_Exercice_Update_Column;
(function (Board_Exercice_Update_Column) {
    /** column name */
    Board_Exercice_Update_Column["BoardId"] = "board_id";
    /** column name */
    Board_Exercice_Update_Column["ExerciceId"] = "exercice_id";
})(Board_Exercice_Update_Column || (Board_Exercice_Update_Column = {}));
/** select columns of table "board" */
export var Board_Select_Column;
(function (Board_Select_Column) {
    /** column name */
    Board_Select_Column["DaysOff"] = "days_off";
    /** column name */
    Board_Select_Column["Id"] = "id";
    /** column name */
    Board_Select_Column["Level"] = "level";
    Board_Select_Column["Name"] = "name";
})(Board_Select_Column || (Board_Select_Column = {}));
/** update columns of table "board" */
export var Board_Update_Column;
(function (Board_Update_Column) {
    /** column name */
    Board_Update_Column["DaysOff"] = "days_off";
    /** column name */
    Board_Update_Column["Id"] = "id";
    /** column name */
    Board_Update_Column["Level"] = "level";
})(Board_Update_Column || (Board_Update_Column = {}));
/** unique or primary key constraints on table "boards_competitions" */
export var Boards_Competitions_Constraint;
(function (Boards_Competitions_Constraint) {
    /** unique or primary key constraint */
    Boards_Competitions_Constraint["BoardsCompetitionsPkey"] = "boards_competitions_pkey";
})(Boards_Competitions_Constraint || (Boards_Competitions_Constraint = {}));
/** select columns of table "boards_competitions" */
export var Boards_Competitions_Select_Column;
(function (Boards_Competitions_Select_Column) {
    /** column name */
    Boards_Competitions_Select_Column["BoardId"] = "board_id";
    /** column name */
    Boards_Competitions_Select_Column["CompetitionId"] = "competition_id";
})(Boards_Competitions_Select_Column || (Boards_Competitions_Select_Column = {}));
/** update columns of table "boards_competitions" */
export var Boards_Competitions_Update_Column;
(function (Boards_Competitions_Update_Column) {
    /** column name */
    Boards_Competitions_Update_Column["BoardId"] = "board_id";
    /** column name */
    Boards_Competitions_Update_Column["CompetitionId"] = "competition_id";
})(Boards_Competitions_Update_Column || (Boards_Competitions_Update_Column = {}));
/** unique or primary key constraints on table "competitions" */
export var Competitions_Constraint;
(function (Competitions_Constraint) {
    /** unique or primary key constraint */
    Competitions_Constraint["CompetitionsPkey"] = "competitions_pkey";
})(Competitions_Constraint || (Competitions_Constraint = {}));
/** select columns of table "competitions" */
export var Competitions_Select_Column;
(function (Competitions_Select_Column) {
    /** column name */
    Competitions_Select_Column["DateEnd"] = "date_end";
    /** column name */
    Competitions_Select_Column["DateStart"] = "date_start";
    /** column name */
    Competitions_Select_Column["Id"] = "id";
    /** column name */
    Competitions_Select_Column["Location"] = "location";
    /** column name */
    Competitions_Select_Column["Name"] = "name";
    /** column name */
    Competitions_Select_Column["RegistrationLink"] = "registration_link";
})(Competitions_Select_Column || (Competitions_Select_Column = {}));
/** update columns of table "competitions" */
export var Competitions_Update_Column;
(function (Competitions_Update_Column) {
    /** column name */
    Competitions_Update_Column["DateEnd"] = "date_end";
    /** column name */
    Competitions_Update_Column["DateStart"] = "date_start";
    /** column name */
    Competitions_Update_Column["Id"] = "id";
    /** column name */
    Competitions_Update_Column["Location"] = "location";
    /** column name */
    Competitions_Update_Column["Name"] = "name";
    /** column name */
    Competitions_Update_Column["RegistrationLink"] = "registration_link";
})(Competitions_Update_Column || (Competitions_Update_Column = {}));
/** unique or primary key constraints on table "config" */
export var Config_Constraint;
(function (Config_Constraint) {
    /** unique or primary key constraint */
    Config_Constraint["ConfigPkey"] = "config_pkey";
})(Config_Constraint || (Config_Constraint = {}));
/** select columns of table "config" */
export var Config_Select_Column;
(function (Config_Select_Column) {
    /** column name */
    Config_Select_Column["Id"] = "id";
    /** column name */
    Config_Select_Column["SendInvitationEmail"] = "send_invitation_email";
})(Config_Select_Column || (Config_Select_Column = {}));
/** update columns of table "config" */
export var Config_Update_Column;
(function (Config_Update_Column) {
    /** column name */
    Config_Update_Column["Id"] = "id";
    /** column name */
    Config_Update_Column["SendInvitationEmail"] = "send_invitation_email";
})(Config_Update_Column || (Config_Update_Column = {}));
/** unique or primary key constraints on table "event" */
export var Event_Constraint;
(function (Event_Constraint) {
    /** unique or primary key constraint */
    Event_Constraint["EventPkey"] = "event_pkey";
})(Event_Constraint || (Event_Constraint = {}));
/** select columns of table "event_public" */
export var Event_Public_Select_Column;
(function (Event_Public_Select_Column) {
    /** column name */
    Event_Public_Select_Column["CreatedAt"] = "created_at";
    /** column name */
    Event_Public_Select_Column["Id"] = "id";
    /** column name */
    Event_Public_Select_Column["PrId"] = "pr_id";
    /** column name */
    Event_Public_Select_Column["Type"] = "type";
})(Event_Public_Select_Column || (Event_Public_Select_Column = {}));
/** select columns of table "event" */
export var Event_Select_Column;
(function (Event_Select_Column) {
    /** column name */
    Event_Select_Column["CreatedAt"] = "created_at";
    /** column name */
    Event_Select_Column["Id"] = "id";
    /** column name */
    Event_Select_Column["PrId"] = "pr_id";
    /** column name */
    Event_Select_Column["Type"] = "type";
})(Event_Select_Column || (Event_Select_Column = {}));
/** unique or primary key constraints on table "event_type" */
export var Event_Type_Constraint;
(function (Event_Type_Constraint) {
    /** unique or primary key constraint */
    Event_Type_Constraint["EventTypePkey"] = "event_type_pkey";
})(Event_Type_Constraint || (Event_Type_Constraint = {}));
export var Event_Type_Enum;
(function (Event_Type_Enum) {
    Event_Type_Enum["Pr"] = "PR";
})(Event_Type_Enum || (Event_Type_Enum = {}));
/** select columns of table "event_type" */
export var Event_Type_Select_Column;
(function (Event_Type_Select_Column) {
    /** column name */
    Event_Type_Select_Column["Name"] = "name";
})(Event_Type_Select_Column || (Event_Type_Select_Column = {}));
/** update columns of table "event_type" */
export var Event_Type_Update_Column;
(function (Event_Type_Update_Column) {
    /** column name */
    Event_Type_Update_Column["Name"] = "name";
})(Event_Type_Update_Column || (Event_Type_Update_Column = {}));
/** update columns of table "event" */
export var Event_Update_Column;
(function (Event_Update_Column) {
    /** column name */
    Event_Update_Column["CreatedAt"] = "created_at";
    /** column name */
    Event_Update_Column["Id"] = "id";
    /** column name */
    Event_Update_Column["PrId"] = "pr_id";
    /** column name */
    Event_Update_Column["Type"] = "type";
})(Event_Update_Column || (Event_Update_Column = {}));
/** unique or primary key constraints on table "exercice_category" */
export var Exercice_Category_Constraint;
(function (Exercice_Category_Constraint) {
    /** unique or primary key constraint */
    Exercice_Category_Constraint["ExerciceCategoryNameKey"] = "exercice_category_name_key";
    /** unique or primary key constraint */
    Exercice_Category_Constraint["ExerciceCategoryPkey"] = "exercice_category_pkey";
})(Exercice_Category_Constraint || (Exercice_Category_Constraint = {}));
/** select columns of table "exercice_category" */
export var Exercice_Category_Select_Column;
(function (Exercice_Category_Select_Column) {
    /** column name */
    Exercice_Category_Select_Column["Id"] = "id";
    /** column name */
    Exercice_Category_Select_Column["Name"] = "name";
})(Exercice_Category_Select_Column || (Exercice_Category_Select_Column = {}));
/** update columns of table "exercice_category" */
export var Exercice_Category_Update_Column;
(function (Exercice_Category_Update_Column) {
    /** column name */
    Exercice_Category_Update_Column["Id"] = "id";
    /** column name */
    Exercice_Category_Update_Column["Name"] = "name";
})(Exercice_Category_Update_Column || (Exercice_Category_Update_Column = {}));
/** unique or primary key constraints on table "exercice" */
export var Exercice_Constraint;
(function (Exercice_Constraint) {
    /** unique or primary key constraint */
    Exercice_Constraint["ExerciceNameExerciceCategoryIdKey"] = "exercice_name_exercice_category_id_key";
    /** unique or primary key constraint */
    Exercice_Constraint["ExercicePkey"] = "exercice_pkey";
    /** unique or primary key constraint */
    Exercice_Constraint["ExerciceSortExerciceCategoryIdKey"] = "exercice_sort_exercice_category_id_key";
})(Exercice_Constraint || (Exercice_Constraint = {}));
/** select columns of table "exercice" */
export var Exercice_Select_Column;
(function (Exercice_Select_Column) {
    /** column name */
    Exercice_Select_Column["ExerciceCategoryId"] = "exercice_category_id";
    /** column name */
    Exercice_Select_Column["Id"] = "id";
    /** column name */
    Exercice_Select_Column["Name"] = "name";
    /** column name */
    Exercice_Select_Column["Sort"] = "sort";
    /** column name */
    Exercice_Select_Column["Unit"] = "unit";
})(Exercice_Select_Column || (Exercice_Select_Column = {}));
/** update columns of table "exercice" */
export var Exercice_Update_Column;
(function (Exercice_Update_Column) {
    /** column name */
    Exercice_Update_Column["ExerciceCategoryId"] = "exercice_category_id";
    /** column name */
    Exercice_Update_Column["Id"] = "id";
    /** column name */
    Exercice_Update_Column["Name"] = "name";
    /** column name */
    Exercice_Update_Column["Sort"] = "sort";
    /** column name */
    Exercice_Update_Column["Unit"] = "unit";
})(Exercice_Update_Column || (Exercice_Update_Column = {}));
/** column ordering options */
export var Order_By;
(function (Order_By) {
    /** in the ascending order, nulls last */
    Order_By["Asc"] = "asc";
    /** in the ascending order, nulls first */
    Order_By["AscNullsFirst"] = "asc_nulls_first";
    /** in the ascending order, nulls last */
    Order_By["AscNullsLast"] = "asc_nulls_last";
    /** in the descending order, nulls first */
    Order_By["Desc"] = "desc";
    /** in the descending order, nulls first */
    Order_By["DescNullsFirst"] = "desc_nulls_first";
    /** in the descending order, nulls last */
    Order_By["DescNullsLast"] = "desc_nulls_last";
})(Order_By || (Order_By = {}));
/** unique or primary key constraints on table "pr" */
export var Pr_Constraint;
(function (Pr_Constraint) {
    /** unique or primary key constraint */
    Pr_Constraint["PrPkey"] = "pr_pkey";
    /** unique or primary key constraint */
    Pr_Constraint["PrUserIdExerciceIdCreatedAtKey"] = "pr_user_id_exercice_id_created_at_key";
})(Pr_Constraint || (Pr_Constraint = {}));
/** select columns of table "pr" */
export var Pr_Select_Column;
(function (Pr_Select_Column) {
    /** column name */
    Pr_Select_Column["CreatedAt"] = "created_at";
    /** column name */
    Pr_Select_Column["ExerciceId"] = "exercice_id";
    /** column name */
    Pr_Select_Column["Id"] = "id";
    /** column name */
    Pr_Select_Column["UserId"] = "user_id";
    /** column name */
    Pr_Select_Column["Value"] = "value";
    /** column name */
    Pr_Select_Column["WeightUnit"] = "weight_unit";
})(Pr_Select_Column || (Pr_Select_Column = {}));
/** update columns of table "pr" */
export var Pr_Update_Column;
(function (Pr_Update_Column) {
    /** column name */
    Pr_Update_Column["CreatedAt"] = "created_at";
    /** column name */
    Pr_Update_Column["ExerciceId"] = "exercice_id";
    /** column name */
    Pr_Update_Column["Id"] = "id";
    /** column name */
    Pr_Update_Column["UserId"] = "user_id";
    /** column name */
    Pr_Update_Column["Value"] = "value";
    /** column name */
    Pr_Update_Column["WeightUnit"] = "weight_unit";
})(Pr_Update_Column || (Pr_Update_Column = {}));
/** unique or primary key constraints on table "role" */
export var Role_Constraint;
(function (Role_Constraint) {
    /** unique or primary key constraint */
    Role_Constraint["RolePkey"] = "role_pkey";
})(Role_Constraint || (Role_Constraint = {}));
export var Role_Enum;
(function (Role_Enum) {
    Role_Enum["Coach"] = "coach";
    Role_Enum["Member"] = "member";
    Role_Enum["Staff"] = "staff";
})(Role_Enum || (Role_Enum = {}));
/** select columns of table "role" */
export var Role_Select_Column;
(function (Role_Select_Column) {
    /** column name */
    Role_Select_Column["Name"] = "name";
})(Role_Select_Column || (Role_Select_Column = {}));
/** update columns of table "role" */
export var Role_Update_Column;
(function (Role_Update_Column) {
    /** column name */
    Role_Update_Column["Name"] = "name";
})(Role_Update_Column || (Role_Update_Column = {}));
/** unique or primary key constraints on table "training_by_date" */
export var Training_By_Date_Constraint;
(function (Training_By_Date_Constraint) {
    /** unique or primary key constraint */
    Training_By_Date_Constraint["TrainingByDatesPkey"] = "training_by_dates_pkey";
})(Training_By_Date_Constraint || (Training_By_Date_Constraint = {}));
/** select columns of table "training_by_date_public" */
export var Training_By_Date_Public_Select_Column;
(function (Training_By_Date_Public_Select_Column) {
    /** column name */
    Training_By_Date_Public_Select_Column["BoardId"] = "board_id";
    /** column name */
    Training_By_Date_Public_Select_Column["Date"] = "date";
    /** column name */
    Training_By_Date_Public_Select_Column["Id"] = "id";
    /** column name */
    Training_By_Date_Public_Select_Column["TrainingByWeekId"] = "training_by_week_id";
})(Training_By_Date_Public_Select_Column || (Training_By_Date_Public_Select_Column = {}));
/** select columns of table "training_by_date" */
export var Training_By_Date_Select_Column;
(function (Training_By_Date_Select_Column) {
    /** column name */
    Training_By_Date_Select_Column["BoardId"] = "board_id";
    /** column name */
    Training_By_Date_Select_Column["Date"] = "date";
    /** column name */
    Training_By_Date_Select_Column["Id"] = "id";
    /** column name */
    Training_By_Date_Select_Column["TrainingByWeekId"] = "training_by_week_id";
})(Training_By_Date_Select_Column || (Training_By_Date_Select_Column = {}));
/** update columns of table "training_by_date" */
export var Training_By_Date_Update_Column;
(function (Training_By_Date_Update_Column) {
    /** column name */
    Training_By_Date_Update_Column["BoardId"] = "board_id";
    /** column name */
    Training_By_Date_Update_Column["Date"] = "date";
    /** column name */
    Training_By_Date_Update_Column["Id"] = "id";
    /** column name */
    Training_By_Date_Update_Column["TrainingByWeekId"] = "training_by_week_id";
})(Training_By_Date_Update_Column || (Training_By_Date_Update_Column = {}));
/** unique or primary key constraints on table "training_by_week" */
export var Training_By_Week_Constraint;
(function (Training_By_Week_Constraint) {
    /** unique or primary key constraint */
    Training_By_Week_Constraint["TrainingByWeeksBoardIdWeekYearDayKey"] = "training_by_weeks_board_id_week_year_day_key";
    /** unique or primary key constraint */
    Training_By_Week_Constraint["TrainingByWeeksPkey"] = "training_by_weeks_pkey";
})(Training_By_Week_Constraint || (Training_By_Week_Constraint = {}));
/** select columns of table "training_by_week_public" */
export var Training_By_Week_Public_Select_Column;
(function (Training_By_Week_Public_Select_Column) {
    /** column name */
    Training_By_Week_Public_Select_Column["BoardId"] = "board_id";
    /** column name */
    Training_By_Week_Public_Select_Column["Content"] = "content";
    /** column name */
    Training_By_Week_Public_Select_Column["Day"] = "day";
    /** column name */
    Training_By_Week_Public_Select_Column["ExtraAerobic"] = "extra_aerobic";
    /** column name */
    Training_By_Week_Public_Select_Column["ExtraDouble"] = "extra_double";
    /** column name */
    Training_By_Week_Public_Select_Column["ExtraGym"] = "extra_gym";
    /** column name */
    Training_By_Week_Public_Select_Column["ExtraStrength"] = "extra_strength";
    /** column name */
    Training_By_Week_Public_Select_Column["Id"] = "id";
    /** column name */
    Training_By_Week_Public_Select_Column["Week"] = "week";
    /** column name */
    Training_By_Week_Public_Select_Column["Year"] = "year";
})(Training_By_Week_Public_Select_Column || (Training_By_Week_Public_Select_Column = {}));
/** select columns of table "training_by_week" */
export var Training_By_Week_Select_Column;
(function (Training_By_Week_Select_Column) {
    /** column name */
    Training_By_Week_Select_Column["BoardId"] = "board_id";
    /** column name */
    Training_By_Week_Select_Column["Content"] = "content";
    /** column name */
    Training_By_Week_Select_Column["Day"] = "day";
    /** column name */
    Training_By_Week_Select_Column["ExtraAerobic"] = "extra_aerobic";
    /** column name */
    Training_By_Week_Select_Column["ExtraDouble"] = "extra_double";
    /** column name */
    Training_By_Week_Select_Column["ExtraGym"] = "extra_gym";
    /** column name */
    Training_By_Week_Select_Column["ExtraStrength"] = "extra_strength";
    /** column name */
    Training_By_Week_Select_Column["Id"] = "id";
    /** column name */
    Training_By_Week_Select_Column["Week"] = "week";
    /** column name */
    Training_By_Week_Select_Column["Year"] = "year";
})(Training_By_Week_Select_Column || (Training_By_Week_Select_Column = {}));
/** update columns of table "training_by_week" */
export var Training_By_Week_Update_Column;
(function (Training_By_Week_Update_Column) {
    /** column name */
    Training_By_Week_Update_Column["BoardId"] = "board_id";
    /** column name */
    Training_By_Week_Update_Column["Content"] = "content";
    /** column name */
    Training_By_Week_Update_Column["Day"] = "day";
    /** column name */
    Training_By_Week_Update_Column["ExtraAerobic"] = "extra_aerobic";
    /** column name */
    Training_By_Week_Update_Column["ExtraDouble"] = "extra_double";
    /** column name */
    Training_By_Week_Update_Column["ExtraGym"] = "extra_gym";
    /** column name */
    Training_By_Week_Update_Column["ExtraStrength"] = "extra_strength";
    /** column name */
    Training_By_Week_Update_Column["Id"] = "id";
    /** column name */
    Training_By_Week_Update_Column["Week"] = "week";
    /** column name */
    Training_By_Week_Update_Column["Year"] = "year";
})(Training_By_Week_Update_Column || (Training_By_Week_Update_Column = {}));
/** unique or primary key constraints on table "unit" */
export var Unit_Constraint;
(function (Unit_Constraint) {
    /** unique or primary key constraint */
    Unit_Constraint["UnitPkey1"] = "unit_pkey1";
})(Unit_Constraint || (Unit_Constraint = {}));
export var Unit_Enum;
(function (Unit_Enum) {
    Unit_Enum["Cal"] = "cal";
    Unit_Enum["Meter"] = "meter";
    Unit_Enum["Rep"] = "rep";
    Unit_Enum["Time"] = "time";
    Unit_Enum["Weight"] = "weight";
})(Unit_Enum || (Unit_Enum = {}));
/** select columns of table "unit" */
export var Unit_Select_Column;
(function (Unit_Select_Column) {
    /** column name */
    Unit_Select_Column["Name"] = "name";
})(Unit_Select_Column || (Unit_Select_Column = {}));
/** update columns of table "unit" */
export var Unit_Update_Column;
(function (Unit_Update_Column) {
    /** column name */
    Unit_Update_Column["Name"] = "name";
})(Unit_Update_Column || (Unit_Update_Column = {}));
/** unique or primary key constraints on table "user" */
export var User_Constraint;
(function (User_Constraint) {
    /** unique or primary key constraint */
    User_Constraint["UsersEmailKey"] = "users_email_key";
    /** unique or primary key constraint */
    User_Constraint["UsersFirebaseUidKey"] = "users_firebase_uid_key";
    /** unique or primary key constraint */
    User_Constraint["UsersPkey"] = "users_pkey";
})(User_Constraint || (User_Constraint = {}));
/** select columns of table "user_current" */
export var User_Current_Select_Column;
(function (User_Current_Select_Column) {
    /** column name */
    User_Current_Select_Column["BirthDate"] = "birth_date";
    /** column name */
    User_Current_Select_Column["BoardId"] = "board_id";
    /** column name */
    User_Current_Select_Column["Email"] = "email";
    /** column name */
    User_Current_Select_Column["FirebaseUid"] = "firebase_uid";
    /** column name */
    User_Current_Select_Column["Firstname"] = "firstname";
    /** column name */
    User_Current_Select_Column["Gender"] = "gender";
    /** column name */
    User_Current_Select_Column["Id"] = "id";
    /** column name */
    User_Current_Select_Column["Lastname"] = "lastname";
    /** column name */
    User_Current_Select_Column["OptionExtraAerobic"] = "option_extra_aerobic";
    /** column name */
    User_Current_Select_Column["OptionExtraDouble"] = "option_extra_double";
    /** column name */
    User_Current_Select_Column["OptionExtraGym"] = "option_extra_gym";
    /** column name */
    User_Current_Select_Column["OptionExtraStrength"] = "option_extra_strength";
    /** column name */
    User_Current_Select_Column["Phone"] = "phone";
    /** column name */
    User_Current_Select_Column["Picture"] = "picture";
    /** column name */
    User_Current_Select_Column["ProfileComplete"] = "profile_complete";
    /** column name */
    User_Current_Select_Column["ProfilePrivate"] = "profile_private";
    /** column name */
    User_Current_Select_Column["Role"] = "role";
    /** column name */
    User_Current_Select_Column["Status"] = "status";
})(User_Current_Select_Column || (User_Current_Select_Column = {}));
/** select columns of table "user_private" */
export var User_Private_Select_Column;
(function (User_Private_Select_Column) {
    /** column name */
    User_Private_Select_Column["BirthDate"] = "birth_date";
    /** column name */
    User_Private_Select_Column["Email"] = "email";
    /** column name */
    User_Private_Select_Column["FirebaseUid"] = "firebase_uid";
    /** column name */
    User_Private_Select_Column["OptionExtraAerobic"] = "option_extra_aerobic";
    /** column name */
    User_Private_Select_Column["OptionExtraDouble"] = "option_extra_double";
    /** column name */
    User_Private_Select_Column["OptionExtraGym"] = "option_extra_gym";
    /** column name */
    User_Private_Select_Column["OptionExtraStrength"] = "option_extra_strength";
    /** column name */
    User_Private_Select_Column["Phone"] = "phone";
    /** column name */
    User_Private_Select_Column["ProfileComplete"] = "profile_complete";
    /** column name */
    User_Private_Select_Column["Status"] = "status";
    /** column name */
    User_Private_Select_Column["Status2"] = "status2";
    /** column name */
    User_Private_Select_Column["UserId"] = "user_id";
})(User_Private_Select_Column || (User_Private_Select_Column = {}));
/** select columns of table "user_public" */
export var User_Public_Select_Column;
(function (User_Public_Select_Column) {
    /** column name */
    User_Public_Select_Column["BoardId"] = "board_id";
    /** column name */
    User_Public_Select_Column["Firstname"] = "firstname";
    /** column name */
    User_Public_Select_Column["Gender"] = "gender";
    /** column name */
    User_Public_Select_Column["Id"] = "id";
    /** column name */
    User_Public_Select_Column["Lastname"] = "lastname";
    /** column name */
    User_Public_Select_Column["Picture"] = "picture";
    /** column name */
    User_Public_Select_Column["ProfilePrivate"] = "profile_private";
    /** column name */
    User_Public_Select_Column["Role"] = "role";
})(User_Public_Select_Column || (User_Public_Select_Column = {}));
/** select columns of table "user" */
export var User_Select_Column;
(function (User_Select_Column) {
    /** column name */
    User_Select_Column["BirthDate"] = "birth_date";
    /** column name */
    User_Select_Column["BoardId"] = "board_id";
    /** column name */
    User_Select_Column["Email"] = "email";
    /** column name */
    User_Select_Column["FirebaseUid"] = "firebase_uid";
    /** column name */
    User_Select_Column["Firstname"] = "firstname";
    /** column name */
    User_Select_Column["Gender"] = "gender";
    /** column name */
    User_Select_Column["Id"] = "id";
    /** column name */
    User_Select_Column["InviteDate"] = "invite_date";
    /** column name */
    User_Select_Column["Lastname"] = "lastname";
    /** column name */
    User_Select_Column["NameNormalized"] = "name_normalized";
    /** column name */
    User_Select_Column["OptionExtraAerobic"] = "option_extra_aerobic";
    /** column name */
    User_Select_Column["OptionExtraDouble"] = "option_extra_double";
    /** column name */
    User_Select_Column["OptionExtraGym"] = "option_extra_gym";
    /** column name */
    User_Select_Column["OptionExtraStrength"] = "option_extra_strength";
    /** column name */
    User_Select_Column["Phone"] = "phone";
    /** column name */
    User_Select_Column["Picture"] = "picture";
    /** column name */
    User_Select_Column["ProfileComplete"] = "profile_complete";
    /** column name */
    User_Select_Column["ProfilePrivate"] = "profile_private";
    /** column name */
    User_Select_Column["Role"] = "role";
    /** column name */
    User_Select_Column["Status"] = "status";
    /** column name */
    User_Select_Column["Status2"] = "status2";
})(User_Select_Column || (User_Select_Column = {}));
/** unique or primary key constraints on table "user_status2" */
export var User_Status2_Constraint;
(function (User_Status2_Constraint) {
    /** unique or primary key constraint */
    User_Status2_Constraint["UserStatus2Pkey"] = "user_status2_pkey";
})(User_Status2_Constraint || (User_Status2_Constraint = {}));
export var User_Status2_Enum;
(function (User_Status2_Enum) {
    User_Status2_Enum["Active"] = "active";
    User_Status2_Enum["Disabled"] = "disabled";
    User_Status2_Enum["Invited"] = "invited";
})(User_Status2_Enum || (User_Status2_Enum = {}));
/** select columns of table "user_status2" */
export var User_Status2_Select_Column;
(function (User_Status2_Select_Column) {
    /** column name */
    User_Status2_Select_Column["Value"] = "value";
})(User_Status2_Select_Column || (User_Status2_Select_Column = {}));
/** update columns of table "user_status2" */
export var User_Status2_Update_Column;
(function (User_Status2_Update_Column) {
    /** column name */
    User_Status2_Update_Column["Value"] = "value";
})(User_Status2_Update_Column || (User_Status2_Update_Column = {}));
/** update columns of table "user" */
export var User_Update_Column;
(function (User_Update_Column) {
    /** column name */
    User_Update_Column["BirthDate"] = "birth_date";
    /** column name */
    User_Update_Column["BoardId"] = "board_id";
    /** column name */
    User_Update_Column["Email"] = "email";
    /** column name */
    User_Update_Column["FirebaseUid"] = "firebase_uid";
    /** column name */
    User_Update_Column["Firstname"] = "firstname";
    /** column name */
    User_Update_Column["Gender"] = "gender";
    /** column name */
    User_Update_Column["Id"] = "id";
    /** column name */
    User_Update_Column["InviteDate"] = "invite_date";
    /** column name */
    User_Update_Column["Lastname"] = "lastname";
    /** column name */
    User_Update_Column["NameNormalized"] = "name_normalized";
    /** column name */
    User_Update_Column["OptionExtraAerobic"] = "option_extra_aerobic";
    /** column name */
    User_Update_Column["OptionExtraDouble"] = "option_extra_double";
    /** column name */
    User_Update_Column["OptionExtraGym"] = "option_extra_gym";
    /** column name */
    User_Update_Column["OptionExtraStrength"] = "option_extra_strength";
    /** column name */
    User_Update_Column["Phone"] = "phone";
    /** column name */
    User_Update_Column["Picture"] = "picture";
    /** column name */
    User_Update_Column["ProfileComplete"] = "profile_complete";
    /** column name */
    User_Update_Column["ProfilePrivate"] = "profile_private";
    /** column name */
    User_Update_Column["Role"] = "role";
    /** column name */
    User_Update_Column["Status"] = "status";
    /** column name */
    User_Update_Column["Status2"] = "status2";
})(User_Update_Column || (User_Update_Column = {}));
/** unique or primary key constraints on table "users_boards" */
export var Users_Boards_Constraint;
(function (Users_Boards_Constraint) {
    /** unique or primary key constraint */
    Users_Boards_Constraint["UsersBoardsPkey"] = "users_boards_pkey";
})(Users_Boards_Constraint || (Users_Boards_Constraint = {}));
/** select columns of table "users_boards" */
export var Users_Boards_Select_Column;
(function (Users_Boards_Select_Column) {
    /** column name */
    Users_Boards_Select_Column["BoardId"] = "board_id";
    /** column name */
    Users_Boards_Select_Column["UserId"] = "user_id";
})(Users_Boards_Select_Column || (Users_Boards_Select_Column = {}));
/** update columns of table "users_boards" */
export var Users_Boards_Update_Column;
(function (Users_Boards_Update_Column) {
    /** column name */
    Users_Boards_Update_Column["BoardId"] = "board_id";
    /** column name */
    Users_Boards_Update_Column["UserId"] = "user_id";
})(Users_Boards_Update_Column || (Users_Boards_Update_Column = {}));
/** unique or primary key constraints on table "videos" */
export var Videos_Constraint;
(function (Videos_Constraint) {
    /** unique or primary key constraint */
    Videos_Constraint["VideosPkey"] = "videos_pkey";
})(Videos_Constraint || (Videos_Constraint = {}));
/** select columns of table "videos" */
export var Videos_Select_Column;
(function (Videos_Select_Column) {
    /** column name */
    Videos_Select_Column["Id"] = "id";
    /** column name */
    Videos_Select_Column["Link"] = "link";
    /** column name */
    Videos_Select_Column["Name"] = "name";
    /** column name */
    Videos_Select_Column["NameNormalized"] = "name_normalized";
})(Videos_Select_Column || (Videos_Select_Column = {}));
/** update columns of table "videos" */
export var Videos_Update_Column;
(function (Videos_Update_Column) {
    /** column name */
    Videos_Update_Column["Id"] = "id";
    /** column name */
    Videos_Update_Column["Link"] = "link";
    /** column name */
    Videos_Update_Column["Name"] = "name";
    /** column name */
    Videos_Update_Column["NameNormalized"] = "name_normalized";
})(Videos_Update_Column || (Videos_Update_Column = {}));
/** select columns of table "viewer_boards" */
export var Viewer_Boards_Select_Column;
(function (Viewer_Boards_Select_Column) {
    /** column name */
    Viewer_Boards_Select_Column["BoardId"] = "board_id";
})(Viewer_Boards_Select_Column || (Viewer_Boards_Select_Column = {}));
/** select columns of table "viewer" */
export var Viewer_Select_Column;
(function (Viewer_Select_Column) {
    /** column name */
    Viewer_Select_Column["UserId"] = "user_id";
})(Viewer_Select_Column || (Viewer_Select_Column = {}));
/** unique or primary key constraints on table "weight_unit" */
export var Weight_Unit_Constraint;
(function (Weight_Unit_Constraint) {
    /** unique or primary key constraint */
    Weight_Unit_Constraint["UnitPkey"] = "unit_pkey";
})(Weight_Unit_Constraint || (Weight_Unit_Constraint = {}));
/** select columns of table "weight_unit" */
export var Weight_Unit_Select_Column;
(function (Weight_Unit_Select_Column) {
    /** column name */
    Weight_Unit_Select_Column["Name"] = "name";
})(Weight_Unit_Select_Column || (Weight_Unit_Select_Column = {}));
/** update columns of table "weight_unit" */
export var Weight_Unit_Update_Column;
(function (Weight_Unit_Update_Column) {
    /** column name */
    Weight_Unit_Update_Column["Name"] = "name";
})(Weight_Unit_Update_Column || (Weight_Unit_Update_Column = {}));
